/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListAffiliateReferralsOptions,
  ListAffiliateReferralsResponses,
} from '../types/ListAffiliateReferrals'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Authenticated access. ADMIN can inspect all programs. INTEGRATOR is limited to its own tenant. AFFILIATE_MANAGER can inspect assigned programs within its tenant. Other users must be active registered referrers and see only their own referrals. Deactivation retains historical reports. date defaults to the current UTC day. Daily volume and realized PnL use the selected UTC day; monthly volume and realized PnL use its UTC calendar month. Trade activity, PnL and currency cash-flow counts/dates include only events at or after attributed_at. Signup and KYC fields describe the user profile. Promotional and trading-challenge credits, non-currency assets, pending and rejected withdrawals are excluded from customer cash flows. Discord status is unknown until an integration exists. Each row includes total_volume_usd automatically: USD-quoted FILL notional (sum of absolute quote quantity) since attribution, independent of date. Set include_total_volume=true to load the report-level total across every matching referral, independent of pagination and date. Otherwise the report total is null. Without referrer_id, the total covers all referrals visible to this caller in the program; ordinary referrers remain restricted to their own referrals. Privileged readers may filter disabled referrers for historical reporting. Cross-tenant attributed users retain their actual tenant scope. Load the summary once per program/referrer selection to avoid repeating the full-set aggregation on page/date changes.
 * @summary List referred users and activity
 * {@link /v1/affiliate_programs/:program_id/referrals}
 */
export function listAffiliateReferrals<ThrowOnError extends boolean = true>(
  options: Options<ListAffiliateReferralsOptions, ThrowOnError>,
): Unwrappable<RequestResult<ListAffiliateReferralsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/affiliate_programs/{program_id}/referrals',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListAffiliateReferralsResponses, ThrowOnError>>,
  )
}
